import React, { createContext, useReducer, useEffect } from 'react';
import { authService } from '../services/authService';

const AuthContext = createContext();

const initialState = {
  user: null,
  token: localStorage.getItem('token'),
  userType: localStorage.getItem('userType') || null, // 'admin', 'merchant', or 'customer'
  loading: true,
  isAuthenticated: false
};

const authReducer = (state, action) => {
  switch (action.type) {
    case 'LOGIN_SUCCESS':
      localStorage.setItem('token', action.payload.token);
      localStorage.setItem('userType', action.payload.userType);
      return {
        ...state,
        user: action.payload.user,
        token: action.payload.token,
        userType: action.payload.userType,
        isAuthenticated: true,
        loading: false
      };
    case 'LOGOUT':
      localStorage.removeItem('token');
      localStorage.removeItem('userType');
      return {
        ...state,
        user: null,
        token: null,
        userType: null,
        isAuthenticated: false,
        loading: false
      };
    case 'LOAD_USER':
      return {
        ...state,
        user: action.payload.user,
        userType: action.payload.userType || state.userType,
        isAuthenticated: true,
        loading: false
      };
    case 'AUTH_ERROR':
      localStorage.removeItem('token');
      localStorage.removeItem('userType');
      return {
        ...state,
        user: null,
        token: null,
        userType: null,
        isAuthenticated: false,
        loading: false
      };
    case 'UPDATE_USER':
      return {
        ...state,
        user: { ...state.user, ...action.payload }
      };
    default:
      return state;
  }
};

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, initialState);

  useEffect(() => {
    // Load user on mount if token exists
    if (state.token && state.userType) {
      authService.loadUser(state.userType)
        .then(response => dispatch({ type: 'LOAD_USER', payload: response.data }))
        .catch(() => dispatch({ type: 'AUTH_ERROR' }));
    } else {
      dispatch({ type: 'AUTH_ERROR' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (username, password, userType = 'merchant') => {
    const response = await authService.login({ username, password }, userType);
    // Map backend response to expected format
    // Note: axios interceptor already extracted response.data, so response is the data object
    const payload = {
      token: response.data.token,
      user: response.data.merchant || response.data.admin || response.data.customer,
      userType: userType
    };
    dispatch({ type: 'LOGIN_SUCCESS', payload });
    return response;
  };

  const logout = () => {
    dispatch({ type: 'LOGOUT' });
  };

  const updateUser = (userData) => {
    dispatch({ type: 'UPDATE_USER', payload: userData });
  };

  return (
    <AuthContext.Provider value={{ ...state, login, logout, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
